import * as React from "react";
import Paper from "@mui/material/Paper";
// Removed unused Table components as you are using DataGrid
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TablePagination from "@mui/material/TablePagination";
// import TableRow from "@mui/material/TableRow";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Stack,
  // Removed unused TextField
  // TextField,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
// Removed unused SearchIcon
// import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
// Removed unused PrintIcon
// import PrintIcon from "@mui/icons-material/Print";
import { useNavigate, useLocation } from "react-router-dom";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import axios from "axios";
import api from "../../../utils/Url";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
} from "@mui/x-data-grid";

import { toast } from "react-toastify";

// Removed unused createData function
// function createData(...) { ... }

export default function MenuMaster() {
  const [zones, setZones] = useState([]);
  const [columns, setColumns] = useState<any>([]);
  // Removed unused state related to old TablePagination
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(5);
  // const [rows, setRows] = useState<any>([]);
  // const [records, setRecords] = useState(rows);
  const [isLoading, setIsLoading] = useState(true);
  // Removed unused menu permission state
  // const [menupermisiondata, setMenupermisiondata] = useState<any>();

  const { i18n, t } = useTranslation();
  const location = useLocation();

  const deleteUser = () => {
    Swal.fire({
      title: "Are you sure ?",
      text: "You won't be able to revert this !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete it!",
    }).then((result: any) => {
      if (result.isConfirmed) {
        // console.log("Use clicked ok");
      } else {
        // console.log("Use Clicked Cancel");
      }
    });
  };

  let delete_id = "";
  const accept = () => {
    const collectData = {
      menuId: delete_id,
    };
    console.log("collectData " + JSON.stringify(collectData));
    api
      .delete(`Menu/DeleteMenuMaster`, { data: collectData })
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
        } else {
          toast.error(response.data.mesg);
        }
        getList();
      });
  };
  const reject = () => {
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  const handledeleteClick = (del_id: any) => {
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };

  useEffect(() => {
    getList();
  }, []);

  const routeChangeEdit = (row: any) => {
    let path = `/master/MenuMasterEdit`;
    navigate(path, {
      state: row,
    });
  };

  let navigate = useNavigate();
  const routeChangeAdd = () => {
    let path = `/master/MenuMasterAdd`;
    navigate(path);
  };

  const getList = async () => {
    try {
      const collectData = {
        menuId: -1
      };
      const response = await api.post(
        `Menu/GetMenuMaster`,
        collectData
      );
      const data = response.data.data;
      const zonesWithIds = data.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: zone.menuId,
      }));
      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "actions",
            // CHANGED: Applied the custom header class
            headerClassName: "custom-header",
            headerName: t("text.Action"),
            width: 150,

            renderCell: (params: any) => {
              return [
                <Stack
                  spacing={1}
                  direction="row"
                  sx={{ alignItems: "center", marginTop: "5px" }}
                >
                  <EditIcon
                    style={{
                      fontSize: "20px",
                      color: "blue",
                      cursor: "pointer",
                    }}
                    className="cursor-pointer"
                    onClick={() => routeChangeEdit(params.row)}
                  />
                  <DeleteIcon
                    style={{
                      fontSize: "20px",
                      color: "red",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handledeleteClick(params.row.id);
                    }}
                  />
                </Stack>,
              ];
            },
          },

          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            // CHANGED: Applied the custom header class
            headerClassName: "custom-header",
          },
          {
            field: "parentName",
            headerName: t("text.ParentName"),
            flex: 1,
            // CHANGED: Applied the custom header class
            headerClassName: "custom-header",
          },
          {
            field: "menuName",
            headerName: t("text.MenuName"),
            flex: 1,
            // CHANGED: Applied the custom header class
            headerClassName: "custom-header",
          },
          {
            field: "pageUrl",
            headerName: t("text.PageURL"),
            flex: 1,
            // CHANGED: Applied the custom header class
            headerClassName: "custom-header",
          },
          {
            field: "displayNo",
            headerName: "displayNo",
            flex: 1,
            // CHANGED: Applied the custom header class
            headerClassName: "custom-header",
          },
          {
            field: "icon",
            headerName: t("text.Icon"),
            flex: 1,
            // CHANGED: Applied the custom header class
            headerClassName: "custom-header",
          },

        ];
        setColumns(columns as any);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));

  return (
    <div>
      <Grid item lg={6} sm={6} xs={12}>
        <Card
          style={{
            width: "100%",
            height: "50%",
            backgroundColor: "#E9FDEE",
            border: ".5px solid green ",
          }}
        >
          <Paper
            style={{ padding: "10px" }}
          >
            <ConfirmDialog />
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{ padding: "20px" }}
              align="left"
            >
              {t("text.MenuMaster")}
            </Typography>
            <Divider />

            <Box height={10} />
            <Stack direction="row" spacing={2} className="my-2 mb-2">
              <Button
                onClick={routeChangeAdd}
                variant="contained"
                endIcon={<AddCircleIcon />}
              >
                {t("text.add")}
              </Button>
            </Stack>

            {isLoading ? (
              <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
                <CircularProgress />
              </div>
            ) : (
              <DataGrid
                rows={zones}
                columns={adjustedColumns}
                pageSizeOptions={[5, 10, 25, 50, 100]}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 5 },
                  },
                }}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                autoHeight
                disableRowSelectionOnClick
                sx={{
                  // ADDED: Style for the custom header class
                  "& .custom-header": {
                    backgroundColor: "#2B4593",
                    color: "#ffffff",
                    fontWeight: "bold",
                  },
                  // Style for the toolbar container
                  "& .MuiDataGrid-toolbarContainer": {
                    padding: "8px",
                    backgroundColor: "#f0f0f0",
                    borderBottom: "1px solid #ccc",
                  },
                  // Style for all data cells
                  "& .MuiDataGrid-cell": {
                    borderRight: "1px solid #f0f0f0"
                  }
                }}
              />)}
          </Paper>
        </Card>
      </Grid>
    </div>
  );
}
